import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=25f667a7&scoped=true&"
import script from "./Separator.vue?vue&type=script&lang=js&"
export * from "./Separator.vue?vue&type=script&lang=js&"
import style0 from "./Separator.vue?vue&type=style&index=0&id=25f667a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f667a7",
  null
  
)

export default component.exports